export default "__VITE_ASSET__CXsivAmN__"